<div class="truck-info-panel">
  <sc-flex >
    <div class="icon">
      <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="information">
      <div class="label">{{'carrier' | translate: ['tmc-yard.entity.truck.carrier',
        translationService.language]}}</div>
      <div class="value">{{carrier}}</div>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="information">
      <div class="label">{{'number plate' | translate: ['tmc-yard.entity.truck.numberplate',
        translationService.language]}}</div>
      <div class="value">{{identifier}}</div>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="information">
      <div class="label">{{'name' | translate: ['tmc-yard.entity.truck.driver',
        translationService.language]}}</div>
      <div class="value">{{driver}}</div>
    </div>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
  </sc-flex>
</div>
